
export const GetFormattedSalesTargetData = (apiResponse = {}) => {
    const {
        data,
        totalRecords = '',
        totalPages = '',
        activeCount = '',
        currentPage = '',
        pageSize = '',
        sortBy = '',
        order = '',
    } = apiResponse;

    const formattedSalesTarget = data?.map(GetSalesTargetData);

    return {
        data: formattedSalesTarget,
        totalRecords,
        totalPages,
        activeCount,
        currentPage,
        pageSize,
        sortBy,
        order,
    };
};

// Helper function to map individual items
const GetSalesTargetData = (item = {}) => {
    const {
        id = null,
        salesTargetName = "",
        eligibleStoresCount = null,
        percentTargetAchieved = null,
        pointsAwarded = null,
        startDate,
        endDate,
        status = null,
        reportUrl = null,
        lastUpdatedDate = null,
        updatedBy = "",
        uuid = null,
    } = item;

    return {
        id,
        salesTargetName,
        eligibleStoresCount,
        percentTargetAchieved,
        pointsAwarded,
        startDate: startDate,
        endDate: endDate,
        status,
        reportUrl,
        lastUpdatedDate: lastUpdatedDate,
        updatedBy,
        uuid
    };
};
